module.exports = __webpack_public_path__ + "img/itomanman_comic05.f9b98eae.jpg";